/* Records */
import Records from "./Records.vue";
import ContactsList from "./contacts/ContactsList.vue";
import ContactDetails from "./contacts/ContactDetails.vue";
import AddressesList from "./addresses/AddressesList.vue";
import { Route } from "vue-router";
import { VersionCheckService } from "@/services/VersionCheckService";
export default {
  path: "/records",
  component: Records,
  name: "Records",
  meta: {
    breadcrumb: "records"
  },
  children: [
    {
      path: "contacts",
      name: "ContactsList",
      typeAddress: ":typeAddress",
      component: ContactsList,
      meta: {
        breadcrumb: "records",
        typeAddress: ":typeAddress"
      },
      beforeEnter: (to: Route, from: Route, next: any) => {
        return VersionCheckService.prototype.versionGuard(to, from, next);
      }
    },
    {
      path: "contacts/:id",
      name: "ContactDetails",
      typeAddress: ":typeAddress",
      component: ContactDetails,
      meta: {
        breadcrumb: "records",
        typeAddress: ":typeAddress"
      }
    },
    {
      path: "addresses/:id/:address",
      name: "ContactAddressDetails",
      component: ContactDetails,
      meta: {
        breadcrumb: "records"
      }
    },
    {
      path: "addresses",
      name: "AddressesList",
      component: AddressesList,
      meta: {
        breadcrumb: "records"
      }
    }
  ]
};
